enum WithdrawalsTabList {
  PENDING = 1,
  PROCESSED,
  PAYMENT,
  ALL,
}

export default WithdrawalsTabList
